module.exports = __webpack_public_path__ + "img/fair-wear-logo.e9659a2.svg";